import { Component, computed, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { DialogService, GridContentWidget } from "@eforall/dashboard";
import { ReadonlyAccessWidget } from "../../../readonly-access/readonly-access.widget";
import { AccTeamDialogDataService } from "../acc-team-dialog-data.service";
import { getSetup } from "./grid/get-setup";

@Component({
	selector: 'acc-team-ventures-part',
	standalone: true,
	imports: [
		GridContentWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './ventures.part.html'
})
export class AccTeamVenturesPart {

	private readonly util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	public readonly dialogDataService = inject(AccTeamDialogDataService);

	public dialogBodyHeight = input.required<number>();

	// subtracting 60 to account for padding and tabstrip, also for readonly access bar if applicable 
	public customHeight = computed(() => this.dialogBodyHeight() - 60 - (this.dialogDataService.canEdit() ? 0 : 40));

	public setup = getSetup(this.util, this.dialog, this.dialogDataService);

}